import React from 'react';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';

const layerSelectorStyle = {
    position: "absolute",
    margin: "1em",
    zIndex: 100,
    background: "#f8f8f8",
}

const LayerSelector = ({selectedLayerValue, selectLayer}) =>{
    const radios = [
        { name: 'Gemeinden', value: '1' },
        { name: '1.000m Rasterzellen', value: '2' },
        { name: '500m Rasterzellen', value: '3' },
    ];

    return(
        <ButtonGroup style={layerSelectorStyle}>
            {radios.map((radio, idx) => (
                <ToggleButton
                    key={idx}
                    id={`radio-${idx}`}
                    type="radio"
                    variant={idx % 2 ? 'outline-success' : 'outline-danger'}
                    name="radio"
                    value={radio.value}
                    checked={selectedLayerValue === radio.value}
                    onChange={selectLayer}
                >
                    {radio.name}
                </ToggleButton>
            ))}
        </ButtonGroup>
    )
}

export default LayerSelector;
